import { Typography } from '@mui/material';
import { type ReactNode, useId } from 'react';

import { FormStack } from '../../atoms/FormStack';
import { Stack } from '../../atoms/Stack';

type Props = {
  title: string;
  subtitle?: string;
  children: ReactNode;
};

export function FormSection(props: Props) {
  const titleId = useId();

  return (
    <section aria-labelledby={titleId}>
      <Stack spacing={2}>
        <Stack spacing={0.5}>
          <Typography id={titleId} variant="h3">{props.title}</Typography>
          {props.subtitle === undefined ? null : <Typography variant="subtitle2">{props.subtitle}</Typography>}
        </Stack>
        <FormStack>
          {props.children}
        </FormStack>
      </Stack>
    </section>
  );
}

export type { Props as FormSectionProps };
